import styled from 'styled-components';

const ColorEntryContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export default ColorEntryContainer;
